import axios from "axios";
import { ElMessageBox, ElMessage } from 'element-plus'
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_WE_CHAT_GROUP_MANAGE,
  // 超时
  timeout: 100000
});
// request拦截器
service.interceptors.request.use(
  config => {
    const timestamp = new Date().getTime();
    config.headers['Timestamp'] = timestamp
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  res => {
    const code = res.data.code;
    if (code) {
      if (code == 1001) {
        ElMessage.closeAll()
        return Promise.reject(res.data.message);
      } else if (code == 1002) {
        ElMessage.closeAll()
        return res.data;
      } else {
        return res.data;
      }
    } else {
      return res;
    }
  },
  error => {
    ElMessage.closeAll()
    return Promise.reject(error);
  }
);

export default service;
